<app-navbar
  (filterChange)="this.page = 0; loadConversations()"
  [totalAssistanceRequired]="totalAssitanceRequired"></app-navbar>
<!-- Shell estilo back office: lienzo muted con paneles elevados flotantes -->
<div
  class="ml-[69px] grid h-screen grid-rows-[minmax(0,1fr)] grid-cols-1 md:grid-cols-[399px_1fr] overflow-hidden bg-surface-muted p-2 gap-2"
  *ngIf="!loading">
  <div
    class="bg-surface-elevated rounded-2xl overflow-hidden md:block hidden">
    <div class="flex flex-col h-full gap-2">
      <div
        class="flex items-center justify-between px-3 font-bold text-black dark:text-white gap-4 pt-4">
        <div class="w-full" *ngIf="inventories.length > 1">
          <app-custom-dropdown-sede
            class="w-full"
            [businessesName]="businessesName"
            [locations]="inventories"
            [selectedInventory]="current_inventory"
            [businessesLogo]="businessesLogo"
            (inventoryChange)="selectInventory($event)">
          </app-custom-dropdown-sede>
        </div>

        <button
          type="button"
          (click)="refreshConversationsAndChat()"
          [disabled]="refreshInProgress"
          [attr.aria-busy]="refreshPhase === 'loading'"
          aria-label="Actualizar conversaciones y chat"
          title="Actualizar conversaciones y chat"
          class="p-2 rounded-lg hover:bg-surface-subtle active:scale-90 active:rotate-180 transition duration-150 ease-out-quart">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            class="refresh-button-icon"
            [class.refresh-button-icon--active]="refreshPhase === 'loading'">
            <path
              d="M15.4286 0C15.1143 0 14.8571 0.255714 14.8571 0.571429V5.18929C13.7214 2.41857 11.0214 0.571429 8 0.571429C4.35714 0.571429 1.275 3.17536 0.675 6.76071C0.622143 7.075 0.832143 7.36786 1.14357 7.42143C1.17536 7.425 1.20714 7.42857 1.23821 7.42857C1.51221 7.42857 1.75429 7.23104 1.80143 6.95214C2.31036 3.91786 4.91786 1.71429 8 1.71429C10.5889 1.71429 12.9036 3.31714 13.8429 5.71429H9.71429C9.4 5.71429 9.14286 5.97143 9.14286 6.28571C9.14286 6.6 9.4 6.85714 9.71429 6.85714H15.4286C15.7429 6.85714 16 6.6 16 6.28571V0.571429C16 0.255714 15.7429 0 15.4286 0ZM14.825 8.57857C14.5119 8.52279 14.2189 8.73593 14.1671 9.04714C13.6893 12.0821 11.0821 14.2857 7.96786 14.2857C5.37893 14.2857 3.06429 12.6829 2.125 10.2857H6.28571C6.6 10.2857 6.85714 10.0286 6.85714 9.71429C6.85714 9.4 6.6 9.14286 6.28571 9.14286H0.571429C0.255714 9.14286 0 9.4 0 9.71429V15.4286C0 15.7429 0.255714 16 0.571429 16C0.887143 16 1.14286 15.7429 1.14286 15.4286V10.8107C2.28 13.5821 4.97857 15.4286 8 15.4286C11.6107 15.4286 14.725 12.8246 15.325 9.23929C15.3786 8.925 15.1679 8.63214 14.825 8.57857Z"
              fill="black"
              class="dark:fill-white" />
          </svg>
        </button>
        <span class="sr-only" role="status" aria-live="polite">
          {{ refreshStatusMessage }}
        </span>
      </div>

      <div
        class="flex items-center bg-surface-muted h-[48px] rounded-lg p-2 mx-4 my-2 text-text transition-shadow duration-150 ease-out-quart focus-within:ring-2 focus-within:ring-border-focus">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="currentColor">
          <path
            d="M15.8531 15.1469L11.4313 10.725C12.4063 9.5875 12.9719 8.11563 12.9719 6.5C12.9719 2.90937 10.0616 0 6.47188 0C2.88219 0 0 2.91031 0 6.5C0 10.0897 2.91001 13 6.47188 13C8.08688 13 9.56094 12.4075 10.6969 11.4328L15.1188 15.8547C15.2438 15.95 15.3719 16 15.5 16C15.6281 16 15.7559 15.9512 15.8534 15.8535C16.05 15.6594 16.05 15.3406 15.8531 15.1469ZM6.50001 12C3.44063 12 1.00001 9.53125 1.00001 6.5C1.00001 3.46875 3.44063 1 6.50001 1C9.55938 1 12 3.44062 12 6.5C12 9.55937 9.53126 12 6.50001 12Z" />
        </svg>
        <input
          type="text"
          [(ngModel)]="searchValue"
          (input)="onSearchInput($event)"
          (keyup.enter)="filterConversations(searchValue)"
          placeholder="Buscar"
          class="flex-1 bg-transparent outline-none border-none ml-2" />
      </div>

      <div
        #mainContainer
        class="flex-1 overflow-auto py-2"
        appInfiniteScroll
        scrollDirection="down"
        (scrollDown)="loadMoreChats ? loadMoreConversations() : ''">
        <nav
          class="grid items-start px-4 text-sm font-medium"
          [appRefreshSurface]="refreshPhase">
          <div
            *ngIf="IsLoadingCustomers"
            class="flex justify-center items-center h-48">
            <app-loader [width]="250" [height]="250"></app-loader>
          </div>
          <div *ngIf="!IsLoadingCustomers">
            <app-chat-tile
              #tiles
              *ngFor="let conversation of conversations; trackBy: trackByPhone"
              [conversation]="conversation"
              (click)="selectConversation(conversation)"></app-chat-tile>
            <div
              *ngIf="conversations.length === 0"
              class="flex justify-center items-center h-48 text-text">
              <p>No hay conversaciones disponibles.</p>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>

  <app-chatroom
    [selectedConversation]="selectedConversation"
    *ngIf="selectedConversation"
    [refreshPhase]="refreshPhase"
    [socketMessage]="socketMessage"
    (conversationResolved)="onConversationResolved($event)"></app-chatroom>
</div>
